import React, { useEffect, useState } from "react";
import { Modal, List, Avatar, Typography, Badge, Spin } from "antd";
import { GetSugeriments } from "../../dao/jutge/GetSugeriments";
import { MarkSugerimentsRead } from "../../dao/jutge/MarkSugerimentsRead";
import { UserOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { AuthContext } from "../../config/AuthContext";
import { useContext } from "react";

interface Props {
    visible: boolean;
    onClose: () => void;
    onRead: () => void; // Callback to refresh counter
}

interface Sugeriment {
    id: number;
    text: string;
    moment: string; // datetime
    visto: number;
    anonim: number;
    nom: string;
    avatar: string;
    id_usuari: number;
}

const AdminSugerimentsModal: React.FC<Props> = ({ visible, onClose, onRead }) => {
    const { userId } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Sugeriment[]>([]);

    useEffect(() => {
        if (visible) {
            loadData();
            markRead();
        }
    }, [visible]);

    const loadData = async () => {
        setLoading(true);
        const res = await GetSugeriments();
        setData(res);
        setLoading(false);
    };

    const markRead = async () => {
        await MarkSugerimentsRead();
        onRead(); // Notify parent to update count to 0
    };

    const handleAcceptRole = async (userIdTarget: number) => {
        if (!userIdTarget) {
            alert("Error: No se ha encontrado el ID del usuario en la solicitud. Por favor, reporta este error.");
            return;
        }
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${apiUrl}:8061/usuaris/${userIdTarget}/rol/profesor`, {
                method: 'POST'
            });
            if (res.ok) {
                alert("Rol actualizado correctamente");
                loadData(); // Refresh list if needed, or maybe remove item? User might want to keep the record.
            } else {
                alert("Error al actualizar rol");
            }
        } catch (e) {
            console.error(e);
            alert("Error de conexión");
        }
    };

    const handleDelete = async (id: number) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const res = await fetch(`${apiUrl}:8061/usuaris/sugeriments/${id}`, {
                method: 'DELETE'
            });
            if (res.ok) {
                loadData();
            } else {
                alert("Error al borrar sugerencia");
            }
        } catch (e) {
            console.error(e);
            alert("Error de conexión");
        }
    };

    const filteredData = data.filter(item => {
        if (item.text === "SOLICITUD_ROL_PROFESOR") {
            return userId === "2"; // Only user 2 sees role requests
        }
        return true;
    });

    return (
        <Modal
            title="Sugerencias e Incidencias Recibidas"
            open={visible}
            onCancel={onClose}
            footer={null}
            width={700}
        >
            {loading ? (
                <div style={{ textAlign: "center", padding: 20 }}><Spin /></div>
            ) : (
                <List
                    itemLayout="horizontal"
                    dataSource={filteredData}
                    renderItem={(item) => {
                        const actions = [
                            <a key="delete" onClick={() => handleDelete(item.id)} style={{ color: 'red' }}>Borrar</a>
                        ];

                        // Add accept action only for role requests and specific user
                        if (item.text === "SOLICITUD_ROL_PROFESOR" && userId === "2") {
                            actions.unshift(
                                <a key="accept" onClick={() => handleAcceptRole(item.id_usuari)}>Aceptar Solicitud</a>
                            );
                        }

                        return (
                            <List.Item actions={actions}>
                                <List.Item.Meta
                                    avatar={
                                        item.avatar ? (
                                            <Avatar src={item.avatar} />
                                        ) : (
                                            <Avatar icon={<UserOutlined />} />
                                        )
                                    }
                                    title={
                                        <span>
                                            <b>{item.nom}</b> - <span style={{ fontSize: 12, color: '#888' }}>{dayjs(item.moment).format("DD/MM/YYYY HH:mm")}</span>
                                            {item.visto === 0 && <Badge status="error" style={{ marginLeft: 8 }} />}
                                        </span>
                                    }
                                    description={<Typography.Paragraph>{item.text}</Typography.Paragraph>}
                                />
                            </List.Item>
                        );
                    }}
                />
            )}
        </Modal>
    );
};

export default AdminSugerimentsModal;
